module.exports = require("@fortawesome/pro-light-svg-icons");